import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faObjectGroup } from '@fortawesome/free-solid-svg-icons';

import Routes from '../../utils/Routes';
import './Navbar.css';

function NavbarBottom() {
    return (
        <div className='navbar-xx'>
            <nav className='navbar-container-xx'>
                <NavLink to={Routes.tablero} className='navbar-item-xx'>
                    <FontAwesomeIcon icon={faList} className='icon-navbar' />
                    <div className='navbar-item-label-xx'>Tablero</div>
                </NavLink>
                <NavLink to={Routes.abms} className='navbar-item-xx'>
                    <FontAwesomeIcon icon={faObjectGroup} className='icon-navbar' />
                    <div className='navbar-item-label-xx'>ABMs</div>
                </NavLink>
            </nav>
        </div>
    );
}

export default NavbarBottom;
